
import * as React from 'react';

import { Typography, Paper, LinearProgress } from "@material-ui/core";
import { ResponsiveContainer, BarChart, XAxis, Legend, Bar, YAxis, CartesianGrid, Tooltip } from 'recharts';

import { NumberPercent, NumberConvert, MoneyLessBRL, NumberLessBRL } from 'src/services';
import { CardBarChartMarketAndGroupAndAreaModal } from './CardBarChartMarketAndGroupAndAreaModal';

// tslint:disable-next-line:no-empty-interface
export interface ICardBarChartMarketAndGroupAndAreaProps {
    data: any[];
    loading: boolean;
    title: string;
    type: string;
}

// tslint:disable-next-line:no-empty-interface
export interface ICardBarChartMarketAndGroupAndAreaState {
}

export interface ICardBarChartMarketAndGroupAndAreaDataChart {
    desc: string;
    id: number;
    groupSales: string;
    groupSalesPercent: number | null;
    marketSales: string;
    marketSalesPercent: number | null;
    storeSales: string;
    storeSalesPercent: number | null;
}

const dataFilled = (data: any) => {
    return data && !!data.length
}

export const convertDataCardBarChartMarketAndGroupAndArea = (dataComplete: any[]
    , type: string
    , showCompleteData: boolean) => {

    let mappedData: ICardBarChartMarketAndGroupAndAreaDataChart[] = [];

    if(dataComplete) {
        let totalGroup : number = 0;
        let totalMarket : number = 0;
        let totalStore : number = 0;
        dataComplete.forEach(e => {
            if(type === 'VOLUME') {
                totalGroup += e.groupSalesVolume ? Number.parseFloat(e.groupSalesVolume.toString()) : 0;
                totalMarket += e.marketSalesVolume ? Number.parseFloat(e.marketSalesVolume.toString()) : 0;
                totalStore += e.storeSalesVolume ? Number.parseFloat(e.storeSalesVolume.toString()) : 0;
            } else {
                totalGroup += e.groupSalesBilling ? Number.parseFloat(e.groupSalesBilling.toString()) : 0;
                totalMarket += e.marketSalesBilling ? Number.parseFloat(e.marketSalesBilling.toString()) : 0;
                totalStore += e.storeSalesBilling ? Number.parseFloat(e.storeSalesBilling.toString()) : 0;
            }
        });
        dataComplete.forEach(e => {
            const item: ICardBarChartMarketAndGroupAndAreaDataChart = {
                desc: e.desc && e.desc.length > 17 ? e.desc.substr(0,17) : e.desc,
                id: e.id,

                groupSales: type === 'VOLUME' ? 
                    (e.groupSalesVolume ? NumberLessBRL(e.groupSalesVolume.toString()) : '0') : 
                    (e.groupSalesBilling ? MoneyLessBRL(e.groupSalesBilling.toString()) : '0'),

                groupSalesPercent: type === 'VOLUME' ? 
                    (e.groupSalesVolume ? NumberPercent(totalGroup,NumberConvert(e.groupSalesVolume.toString())) : 0) : 
                    (e.groupSalesBilling ? NumberPercent(totalGroup,NumberConvert(e.groupSalesBilling.toString())) : 0),
                
                marketSales: type === 'VOLUME' ? 
                    (e.marketSalesVolume ? NumberLessBRL(e.marketSalesVolume.toString()) : '0') :
                    (e.marketSalesBilling ? MoneyLessBRL(e.marketSalesBilling.toString()) : '0'),
                
                marketSalesPercent: type === 'VOLUME' ? 
                    (e.marketSalesVolume ? NumberPercent(totalMarket,NumberConvert(e.marketSalesVolume.toString())) : 0) : 
                    (e.marketSalesBilling ? NumberPercent(totalMarket,NumberConvert(e.marketSalesBilling.toString())) : 0),

                storeSales: type === 'VOLUME' ? 
                    (e.storeSalesVolume ? NumberLessBRL(e.storeSalesVolume.toString()) : '0') : 
                    (e.storeSalesBilling ? MoneyLessBRL(e.storeSalesBilling.toString()) : '0'),

                storeSalesPercent: type === 'VOLUME' ? 
                    (e.storeSalesVolume ? NumberPercent(totalStore,NumberConvert(e.storeSalesVolume.toString())) : 0) : 
                    (e.storeSalesBilling ? NumberPercent(totalStore,NumberConvert(e.storeSalesBilling.toString())) : 0)
            };

            mappedData.push(item);
        });

        mappedData.sort( (obj1:any, obj2: any)=> {
            return obj2.marketSalesPercent - obj1.marketSalesPercent;
        });
        if(!showCompleteData) {
            mappedData = mappedData.slice(0, 5);
        }
    }

    return mappedData;
}

// statless component
export const CustonTooltipDataCardBarChartMarketAndGroupAndBookstore = (props: any) => {

    let content;
    props.payload !== null &&  props.payload.length !== undefined && props.payload.length > 0 ? content = props.payload[0].payload : content = undefined;

    return (<div className="tooltip-box">
        <table>
            <tbody>
            <tr className="tooltip-text">
                    <td className="tooltip-title" colSpan={3}> {content && content.desc} </td>
                </tr>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Mercado:</td>
                    <td className="tooltip-title">{content && content.marketSalesPercent ? content.marketSalesPercent.toFixed(2) : 0}%</td>
                    <td className="tooltip-content">{content && content.marketSales}</td>
                </tr>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Rede de lojas:</td>
                    <td className="tooltip-title">{content && content.groupSalesPercent ? content.groupSalesPercent.toFixed(2) : 0}%</td>
                    <td className="tooltip-content">{content && content.groupSales}</td>
                </tr>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Lojas:</td>
                    <td className="tooltip-title">{content && content.storeSalesPercent ? content.storeSalesPercent.toFixed(2) : 0}%</td>
                    <td className="tooltip-content">{content && content.storeSales}</td>
                </tr>
            </tbody>
        </table>
    </div>
    )
};

// statless component
const CardBarChartMarketAndGroupAndAreaChart = ({ data, dataComplete, loading, type } : 
    { data: ICardBarChartMarketAndGroupAndAreaDataChart[], dataComplete : any, loading:boolean, type: string }) => (
    <div>
        <ResponsiveContainer width="100%" height={345}>
            <BarChart data={data} margin={{ top: 15, right: 20, left: 20, bottom: 80 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis interval={0} dataKey="desc"  tick={{fontSize: 10, angle: -90, dx: -3, dy: 50}}/>
                <YAxis  yAxisId="only" hide={true} />
                <Tooltip content={<CustonTooltipDataCardBarChartMarketAndGroupAndBookstore isAnimationActive={false}  />} />
                <Legend verticalAlign="top" height={20}/>
                <Bar yAxisId="only" dataKey="marketSalesPercent" name="Mercado" fill="#65cc93" />
                <Bar yAxisId="only" dataKey="groupSalesPercent" name="Rede de lojas" fill="#323232" />
                <Bar yAxisId="only" dataKey="storeSalesPercent" name="Lojas" fill="#00aeef" />
            </BarChart>
        </ResponsiveContainer>
        <CardBarChartMarketAndGroupAndAreaModal data={dataComplete} loading={loading} type={type} />
    </div>
);

export class CardBarChartMarketAndGroupAndArea extends React.Component<ICardBarChartMarketAndGroupAndAreaProps, ICardBarChartMarketAndGroupAndAreaState> {

    public render() {
        return  (
            <Paper className="publisher-sale-block panel-block" >
                <Typography variant="headline" className="panel-title" component="title">
                    {this.props.type + ' ' + this.props.title}
                </Typography>
                {
                    this.props.loading
                    ?
                    <LinearProgress />
                    :
                    (
                        dataFilled(this.props.data)
                        ?
                        (
                            <CardBarChartMarketAndGroupAndAreaChart 
                                data={convertDataCardBarChartMarketAndGroupAndArea(
                                    this.props.data
                                    , this.props.type
                                    , false
                                )}
                                dataComplete={this.props.data}
                                loading={this.props.loading}
                                type={this.props.type} 
                            />
                        )
                        :
                        (<Typography variant="body2" className="comparative" component="p">
                            Não há informações de vendas
                        </Typography>)
                    )
                }
            </Paper>
        )
    }
}


// WEBPACK FOOTER //
// ./src/component/shared/layout/components/CardBarChartMarketAndGroupAndArea.tsx